export default () => {
    const button = document.querySelector('.go-back');

    if (!button) {
        return;
    }

    button.addEventListener('click', ()=>{
        window.history.back();
    });
}